export const cmvReportV2 = {
	label: "CMV",
	description:
		"El CMV (Costo de Mercancías Vendidas) es un indicador financiero que representa los costos directos.",
	states: {
		empty: {
			title: "No se encontraron datos de CMV",
			description: "No hay información de CMV para el período seleccionado.",
		},
		error: {
			title: "No se pudo cargar el CMV",
			description:
				"Ocurrió un error al cargar el informe de CMV. Inténtalo de nuevo en unos instantes.",
		},
	},
	kpis: {
		itemsSold: "Artículos vendidos",
		grossRevenue: "Facturación bruta",
		totalCost: "Costo total",
		marginCmv: "Margen CMV",
		cmvPercent: "CMV en porcentaje",
	},
	header: {
		periodPlaceholder: "Seleccione el período",
		export: "Exportar Excel",
		type: {
			all: "Todos los productos",
			fromPlace: "Productos del place",
			fromVendor: "Productos del proveedor",
		},
	},
	filters: {
		searchPlaceholder: "Buscar por producto o SKU",
		categoriesPlaceholder: "Todas las categorías",
		viewBy: {
			byCategory: "Visualizar por categorías",
			byProduct: "Visualizar por productos",
		},
	},
	chart: {
		title: "Facturación vs CMV por categoría",
		legend: {
			revenue: "Facturación",
			cmv: "CMV",
		},
		tooltip: {
			revenue: "Facturación",
			cmv: "CMV",
		},
		empty: {
			title: "Sin datos para el gráfico",
			description:
				"No hay categorías con ventas para el período y filtros seleccionados.",
		},
	},
	table: {
		columns: {
			category: "CATEGORÍA",
			soldQty: "CANT. VENDIDA",
			grossRevenue: "FACTURACIÓN BRUTA",
			totalCost: "COSTO TOTAL",
			costPercent: "COSTO PORCENTUAL",
			cmv: "CMV",
			margin: "MARGEN",
			product: "Producto",
			sku: "SKU",
			productSoldQty: "Cant. vendida",
			losses: "Pérdidas",
			unitValue: "Valor unit.",
			unitCost: "Costo unit.",
			productTotalValue: "Valor total",
			productTotalCost: "Costo total",
			productMargin: "Margen",
			productCmv: "CMV",
		},
		empty: {
			title: "No se encontraron productos",
			description: "No hay productos para los filtros seleccionados.",
		},
	},
	zeroedCost: {
		card: {
			label: "Productos con costo en cero",
			alert: {
				title: "Mejore su CMV",
				description: "Ajuste los costos de los productos.",
				cta: "Ajustar productos",
			},
			success: {
				title: "CMV sin inconsistencias",
				description: "Todos los productos tienen los costos actualizados",
			},
		},
		drawer: {
			title: "Productos con costo en cero",
			back: "Volver",
			cancel: "Cancelar",
			submit: "Actualizar productos",
			success: "Costos actualizados con éxito",
			loading: "Cargando productos...",
			choice: {
				title: "¿Cómo deseas actualizar los costos de los productos en cero?",
				manual: {
					title: "Manualmente",
					description:
						"Visualizas todos los productos en cero y actualizas los costos sin salir del panel.",
				},
				xlsx: {
					title: "En masa vía planilla Excel",
					description:
						"Ponemos a disposición una planilla con todos los productos en cero, la completas con los costos y subes el archivo aquí.",
				},
			},
			manual: {
				subtitle: "Actualizar costos en cero manualmente",
				empty: "Ningún producto con costo en cero.",
				error: "No fue posible cargar los productos.",
				columns: {
					product: "Producto",
					sku: "SKU",
					storage: "Almacén",
					lastCost: "Último costo",
					unitCost: "Costo unitario",
				},
			},
			xlsx: {
				subtitle: "Actualizar costos en cero en masa",
				downloadSheet: "Descargar planilla con productos con costos en cero",
				dropzone: {
					title: "Arrastra y suelta el XLSX para editar en masa",
					action: "o selecciona los archivos",
					helper:
						"Descarga la planilla modelo, modifica los costos de los productos en cero y sube el archivo aquí para actualizar en masa.",
				},
				filesLabel: "1 de 1 archivos",
				file: {
					loadError: "Error al cargar el archivo. Inténtalo de nuevo.",
					rowsError: "La planilla tiene productos con problemas.",
					downloadErrors: "Descargar planilla con errores",
					remove: "Eliminar archivo",
				},
				sheet: {
					fileName: "Productos con costos en cero",
					invalidFileName: "Productos con costos en cero - errores",
					columns: {
						name: "Producto",
						sku: "SKU",
						storage: "Almacén",
						productId: "ID del producto",
						storageId: "ID del almacén",
						lastCost: "Último costo",
						unitCost: "Costo unitario",
					},
				},
			},
		},
		successDialog: {
			windowTitle: "Productos con costos en cero actualizados",
			title: "¡Productos actualizados con éxito!",
			description: "Tu reporte CMV está actualizado.",
			remaining: "Pero existen nuevos productos con costos en cero.",
			confirm: "Entendido",
		},
	},
};
